import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <a href= "https://twitter.com/Hariprasathys">
      <BsTwitter />
    </a>
    <a href='https://www.facebook.com/hariprasath.sathish/'>
      <FaFacebookF />
    </a>
    <a href='https://www.instagram.com/hariprasath_y_s/'>
      <BsInstagram />
    </a>
  </div>
);

export default SocialMedia;